import React, { useRef } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router";
import LocationForm, { LocationFormHandle } from "../LocationForm/LocationForm";
import { Location, ProjectVariable } from "../types/Location";
import useStyles from "../styles/useStyles";

interface Props {
  projectId: string;
  permission: string;
  projectStatus: string;
  locations: Location[];
  projectVariableDefinitions: ProjectVariable[];
}

const New: React.FC<Props> = ({
  projectId,
  permission,
  projectStatus,
  locations,
  projectVariableDefinitions,
}) => {
  const navigate = useNavigate();
  const submitRef = useRef<LocationFormHandle>(null);
  const styles = useStyles();

  return (
    <div className={styles.page}>
      <Card className={styles.card}>
        <Card.Header className={styles.cardHeader}>
          <Row className={styles.headerRow}>
            <Col sm={1}>
              <Button
                className="btnSeawhite"
                onClick={() =>
                  navigate(`/projects/${projectId}/project_locations`, {
                    state: null,
                  })
                }
              >
                Cancel
              </Button>
            </Col>
            <Col className={styles.title} sm={9}>
              Add Location
            </Col>
            {(permission === "create" || permission === "manage") &&
              projectStatus === "building" && (
              <Col>
                <Button
                  className="squareGreenButton"
                  onClick={() => submitRef.current?.saveLocation()}
                >
                  Save
                </Button>
              </Col>
            )}
          </Row>
        </Card.Header>
        <hr className={styles.hr} />
        <Card.Body>
          <LocationForm
            ref={submitRef}
            projectId={projectId}
            locations={locations}
            projectVariableDefinitions={projectVariableDefinitions}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default New;
